import styled from 'styled-components';
import ColumnFilterDropdown from '../columnFilterDropdown';
import ColumnFtsFilter from '../columnFtsFilter';
import useReportDataContext from '../../hooks/useReportDataContext';

// Custom Header Component with Enhanced Filter Support
interface CustomHeaderProps {
  displayName: string;
  column: any;
  api: any;
}

const CustomHeaderComponent = (props: CustomHeaderProps) => {
  const { displayName, column } = props;
  const { columnFilters, ftsFilterKeys } = useReportDataContext();

  if (!column?.getColDef?.()?.field) {
    return <HeaderText>{displayName}</HeaderText>;
  }

  const field = column.getColDef().field;

  // Check if this column has filter data available
  const hasDropdownFilter = columnFilters.some((filter) => filter.accessor === field);
  const hasFtsFilter = ftsFilterKeys.includes(field);

  // Only show filters for columns that have actual filter data
  if (hasDropdownFilter || hasFtsFilter) {
    // Prioritize dropdown filter if available
    if (hasDropdownFilter) {
      const filterData = columnFilters.find((filter) => filter.accessor === field);
      // Only show dropdown if it has meaningful filter values
      if (filterData && filterData.values && filterData.values.length > 1) {
        return (
          <FilterWrapper>
            <ColumnFilterDropdown headerName={displayName} filterKey={field} />
          </FilterWrapper>
        );
      }
    }

    // Use FTS filter if available and no dropdown filter
    if (hasFtsFilter) {
      return (
        <FilterWrapper>
          <ColumnFtsFilter headerName={displayName} filterKey={field} />
        </FilterWrapper>
      );
    }
  }

  // For columns without filter data, return simple header
  return <HeaderText>{displayName}</HeaderText>;
};

export default CustomHeaderComponent;

// Centered header text for columns without filters
const HeaderText = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
`;

// Wrapper for filter components to ensure proper styling
const FilterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: fit-content;
  white-space: nowrap;

  /* Override any theme-based styling issues */
  .column-filter-dropdown,
  .column-fts-filter {
    .filter-dropdown-menu {
      z-index: 999 !important;
    }
  }
`;
